import { createEditorContentUnifiedQueryVariables } from '@confluence/editor-content-unified-query/entry-points/createEditorContentUnifiedQueryVariables.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import EmojiTitleQueryArtifact, {
	type EmojiTitleQuery$data,
	type EmojiTitleQuery$variables,
} from './__generated__/EmojiTitleQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadEmojiTitle = (
	contentId: string,
	draftShareId: EmojiTitleQuery$variables['draftShareId'],
	useCache: boolean,
): Promise<{
	data: EmojiTitleQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<EmojiTitleQuery$data, EmojiTitleQuery$variables>({
		query: EmojiTitleQueryArtifact,
		variables: expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
			? {
					...createEditorContentUnifiedQueryVariables({ contentId, draftShareId }),
					skipPublishedFragment: false,
				}
			: { contentId, draftShareId, status: ['current', 'draft'], skipPublishedFragment: false },
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
